import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { displayMessage } from '../../services/helper';
import React, { useState } from 'react';
import { Button } from 'antd';


export default function SectionGrid({ conrol }) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#631b1b', width: '100%', height: 30 }}>
                <div style={{ width: '15%' }} />
                <div style={{ display: 'flex', flex: 1, color: 'white', alignItems: 'center', justifyContent: 'center' }}>{displayMessage('EXERCISE')}</div>
                <div style={{ width: '10%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: '5%' }}>
                    <Button
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}
                        shape='circle'
                        onClick={() => setIsOpen(!isOpen)}
                        size='small'
                        icon={isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                    />
                </div>
            </div>
            {
                isOpen == true &&
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12, flexWrap: 'wrap', gap: 4, marginTop: 4 }}>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('CAMERA')}</div>
                        <div>{conrol?.camera_position}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('EXECUTION')}</div>
                        <div>{conrol?.correct_execution}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('ATENTION')}</div>
                        <div>{conrol?.concentration_activity}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{`${displayMessage('EXERCISE')} ⭐`}</div>
                        <div>{conrol?.exercise_stars ? conrol?.exercise_stars : displayMessage('NOT_INFORMED2')}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('MANGOS')}</div>
                        <div>{conrol?.exercise_mangos ? conrol?.exercise_mangos : displayMessage('NOT_INFORMED2')}</div>
                    </div>

                </div>
            }
        </div>
    )
}

